import { createColumnHelper } from "@tanstack/react-table";

import { ReactTable } from "components";
import "components/SkeletonTable/SkeletonTable.scss";

type SkeletonTableProps = {
  columnSize: number;
  pageSize: number;
};

const columnHelper = createColumnHelper<number>();

export const SkeletonTable = ({ columnSize, pageSize }: SkeletonTableProps) => {
  const placeholderData = Array.from({ length: pageSize }, (_, index) => index);

  const columns = Array.from({ length: columnSize }, (_, index) =>
    columnHelper.accessor(row => row, { id: index.toString(), header: "", cell: () => <div className="SkeletonTable__row" /> })
  );

  return (
    <div className="SkeletonTable">
      <ReactTable columns={columns} data={placeholderData} />
    </div>
  );
};
